// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__FRkhs","footer":"ModalUpdate_footer__2uCJQ"};